import { combineReducers } from 'redux';
import authReducer from './reducerAuth';
import countryReducer from './reducerCountry';

export default combineReducers({
  auth: authReducer,
  country: countryReducer,
});
